import { useEffect, useState } from 'react';
import './TheProject.css';
import axios from 'axios';
import Cookies from 'js-cookie';

const url = process.env.REACT_APP_URL_LOCAL;
const TheProject = () => {
	const [data, setData] = useState(null);

	useEffect(() => {
		const fetchData = async () => {
			const headers = {
				headers: {
					authorization: `Bearer ${Cookies.get('mazeToken')}`,
				},
			};

			const response = await axios.get(url + '/project-content', headers);
			if (response.data.message === 'OK') {
				console.log(response.data);
				setData(response.data.project);
			}
		};
		fetchData();
	}, []);
	return (
		<>
			<section className="real-web-project-item">
				{data !== null && (
					<>
						<h1
							className="real-web-project-item-title"
							style={{ textDecoration: 'underline' }}
						>
							{data.name}
						</h1>

						<p>{data.description}</p>
						<br />
						{data.sections.map((section, index) => {
							return (
								<div key={index}>
									<div style={{textDecoration:'underline'}}>{section.title}:</div>
									<div>{section.content}</div>
								</div>
							);
						})}
					</>
				)}
			</section>
		</>
	);
};

export default TheProject;
